/*
	Hey there!

	This is the client file for your theme. If you need to do any client-side work in javascript,
	this is where it needs to go.

	You can listen for page changes by writing something like this:

	  $(window).on('action:ajaxify.end', function(data) {
		var	url = data.url;
		console.log('I am now at: ' + url);
	  });
*/

$(document).ready(function() {
    $(window).on('action:ajaxify.end', function () {
        if(localStorage.getItem('cookieconsent-accept') == 1){
        	dataLayer.push({'cookie-consent': 'true'});  
    	}
	    dataLayer.push({'event': 'virtual-pv'});
	    console.log("Lancio PV")
    });
});

function openComposerNuovaDisc(){
		
	$('body').on('click', '.connect_new_topic, #connect_new_topic_btn', function(){
		//console.log(cid);
		if($( ".composer").not('.reply').length){
			$( ".composer" ).each(function( index ) {
					$(this).css('visibility', 'visible');
					if($(this).attr('id')){
						taskId = $(this).attr('id').replace('cmp-uuid-', '');
						$('.taskbar-composer[data-uuid="'+taskId+'"]').addClass('active');
					}
			});
		}else{
 			app.newTopic();
 		}
 		
		});
}
function nuovaDiscIcon(){
	//if(!$('body').hasClass('page-stream') && !$('body').hasClass('page-interest')){
		$('.writePost-icon').html( $('#user_dropdown').html() );
	//}
}
$(document).ready(function() {

	$(window).on('action:ajaxify.start', function(event, data) {
		if(data.url == "intro"){
			window.location.href = '/' + data.url;
		}

		/** COOKIE */
		$(".cookie-consent button").on('click', function(){
		    localStorage.setItem('cookieconsent-accept', 1);
		    dataLayer.push({'cookie-consent': 'true'});
		    var warningEl = $('.cookie-consent');
		    warningEl.remove();
			$(document.body).removeClass('cookie-consent-open');
		});

		$("#closeCookie").on('click', function(){
		    console.log("Cliccato");
		    localStorage.setItem('cookieconsent', 1);
		    localStorage.setItem('cookieconsent-accept', 0);
		    dataLayer.push({'cookie-consent': 'false'});
		    var warningEl = $('.cookie-consent');
		    warningEl.remove();
			$(document.body).removeClass('cookie-consent-open');
		});
	});
	$(window).on('action:ajaxify.end', function(data) {
		/*
		var	url = data.url;
		console.log('I am now at: ' + url);
		*/
		openComposerNuovaDisc();
		nuovaDiscIcon();
		//----------
		if(document.getElementById('connectBread')){
			var hHeight=0;
			const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
			//console.log(vw);
			if(vw>991){
				hHeight = document.getElementById('header-menu').offsetHeight;
			}
			btop= document.getElementById('connectBread').offsetTop;
			var bwidth= document.getElementById('connectBread').offsetWidth;
			
			window.addEventListener("scroll", function(event) {
				if(document.getElementById('connectBread')){
			    	var top = this.scrollY;
			        if(top>=btop){
			        	document.getElementById('connectBread').classList.add('bFixed');
			        	document.getElementById('connectBread').style.width = bwidth+'px';
			        	document.getElementById('connectBread').style.top = hHeight+'px';
			        }else{
			        	document.getElementById('connectBread').classList.remove('bFixed');
			        }
			    }
			}, false);
			window.addEventListener("resize", function(event) {
				if(document.getElementById('connectBread')){
					document.getElementById('connectBread').classList.remove('bFixed');
		        	document.getElementById('connectBread').style.width = '';
		        	document.getElementById('connectBread').style.top = '';
		        }
			}, false);
		}
		//----------------


		

	});
});